// @flow
import client from '../../client'
import getAuthorizedUserId from '../user/getAuthorizedUserId'
import format from '../../utils/format'

type StripOrigin = 'USD' | 'EUR'

export type Options = {
  email?: string,
  currency?: string,
  stripe_origin?: StripOrigin,
}

export type SetupIntentData = {
  customer: string,
  setupintent_id: string,
  setupintent_client_secret: string,
}

export const CREATE_INTENT_ENDPOINT =
  '/auth/users/{0}/payment-options/create_setup_intent/'

export const createSetupIntent = (body: Options): Promise<SetupIntentData> => {
  const userId = getAuthorizedUserId()
  const endpoint = format(CREATE_INTENT_ENDPOINT, userId)
  return client.post(endpoint, { body })
}

export default createSetupIntent
